// extracted by mini-css-extract-plugin
module.exports = {"background":"EventContent_background__2LPDy","contentWrap":"EventContent_contentWrap__2Njj9"};